import React from 'react';
var Actions = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 100 100" },
        React.createElement("path", { fill: fill, fillRule: "evenodd", d: "M50 37c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13zm37 0c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13zm-74 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 57.18 0 50s5.82-13 13-13z" })));
};
export default Actions;
